module.exports = __webpack_public_path__ + "media/theme/ico-comment-1-12c5cef8.png";